import { atom, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useFeatureFlag } from "providers/LaunchDarkly";
import * as R from "remeda";
import { safeJSONStorage } from "utils/safeStorage";

export type PowerUserFeatures = {
  inlineRoster: boolean;
};

const defaultFeatures: PowerUserFeatures = { inlineRoster: false };

const powerUserFeaturesAtom = atomWithStorage<PowerUserFeatures>(
  "powerUserFeatures",
  defaultFeatures,
  safeJSONStorage<PowerUserFeatures>(),
);

export const usePowerUserFeatures = () => {
  const flag = useFeatureFlag("power-tools");
  const [storedFeatures, setFeatures] = useAtom(powerUserFeaturesAtom);

  const menuEnabled = flag.includes("all");
  const features = menuEnabled ? storedFeatures : R.mapValues(defaultFeatures, (_, k) => flag.includes(k));

  return { menuEnabled, features, setFeatures };
};

export const usePowerUserFeature = (key: keyof PowerUserFeatures): boolean => {
  const { features } = usePowerUserFeatures();
  return features[key];
};

export const powerUserMenuAtom = atom(false);
